import { useEffect, useState } from 'react';
import { getGuestMedications, subscribeGuestMedications } from '../utils/guestMedications';

/** The visitor's medications from the tab store, re-rendering on every change. */
export default function useGuestMedications() {
  const [items, setItems] = useState(getGuestMedications);
  useEffect(() => {
    // Re-read once: the store may have changed between render and effect.
    setItems(getGuestMedications());
    return subscribeGuestMedications(setItems);
  }, []);
  return items;
}
